import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * [네트워크 설정 > 보안 정책 위배관리 > 보안정책] 선택한 벤더에 해당하는 정책 위반 정보를 조회한다.
   * @author Song
   * @return {[type]}   [description]
   */
  getNetdevicePolicyViolation(param) {
    return axios.post(`${baseUrl}/settings/netdevice-security-policy/get-target-netdevice-policy-violation.do`, param);
  },
  /**
   * [네트워크 설정 > 보안 정책 위배관리 > 보안정책] 선택한 벤더에 해당하는 정책 위반 정보를 삭제한다.
   * @author Song
   * @return {[type]}   [description]
   */
  deleteNetdevicePolicyViolation(param) {
    return axios.post(`${baseUrl}/settings/netdevice-security-policy/delete-netdevice-policy-violation.do`, param);
  },
  /**
   * [네트워크 설정 > 보안 정책 위배관리 > 보안정책] 보안 정책 위배관리 - 룰목록 조회
   * @author Song
   * @return {[type]}   [description]
   */
  getNetdeviceRuleList(param) {
    return axios.post(`${baseUrl}/settings/netdevice-security-policy/get-target-netdevice-rule-list.do`, param);
  },
  /**
   * [네트워크 설정 > 보안 정책 위배관리 > 보안정책] 보안 정책 위배관리 - 룰목록 삭제
   * @author Song
   * @return {[type]}   [description]
   */
  deleteNetdeviceRuleList(param) {
    return axios.post(`${baseUrl}/settings/netdevice-security-policy/delete-netdevice-rule-list.do`, param);
  },
  /**
   * [네트워크 설정 > 보안 정책 위배관리 > 보안정책] 정책이 등록되지 않은 해당밴더의 장비리스트를 조회한다.
   * @author Song
   * @return {[type]}   [description]
   */
  getNetdeviceInNonPolicy(param) {
    return axios.post(`${baseUrl}/settings/netdevice-security-policy/get-netdevice-non-policy.do`, param);
  },
  /**
   * [네트워크 설정 > 보안 정책 위배관리 > 보안정책] 장비 보안 정책을 추가한다.
   * @author Song
   * @return {[type]}   [description]
   */
  insertNetdevicePolicy(param) {
    return axios.post(`${baseUrl}/settings/netdevice-security-policy/insert-netdevice-policy.do`, param);
  },
  /**
   * [네트워크 설정 > 보안 정책 위배관리 > 보안정책] 장비 보안 정책을 수정한다.
   * @author Song
   * @return {[type]}   [description]
   */
  updateNetdevicePolicy(param) {
    return axios.post(`${baseUrl}/settings/netdevice-security-policy/update-netdevice-policy.do`, param);
  },
  /**
   * [네트워크 설정 > 보안 정책 위배관리 > 보안정책] 권장 스크립트 목록을 가져온다.
   * @author Song
   * @return {[type]}   [description]
   */
  getTemplateList() {
    return axios.get(`${baseUrl}/settings/netdevice-security-policy/get-template-list.do`);
  },
  /**
   * [네트워크 설정 > 보안 정책 위배관리 > 보안정책] 정책 룰 - severity 리스트를 조회한다.
   * @author Song
   * @return {[type]}   [description]
   */
  getRuleSeverity() {
    return axios.get(`${baseUrl}/settings/netdevice-security-policy/get-rule-severity.do`);
  },
  /**
   * [네트워크 설정 > 보안 정책 위배관리 > 보안정책] 정책 룰 - 룰을 추가, 변경한다.
   * @author Song
   * @return {[type]}   [description]
   */
  setNetdevicePolicyRule(param) {
    return axios.post(`${baseUrl}/settings/netdevice-security-policy/set-netdevice-policy-rule.do`, param);
  },
  /**
   * [네트워크 설정 > 보안 정책 위배관리 > 보안정책] 정책 아이디 중복 검사
   * @author Song
   * @return {[type]}   [description]
   */
  checkPolicyId(param) {
    return axios.post(`${baseUrl}/settings/netdevice-security-policy/check-policy-id.do`, param);
  },
  /**
   * [네트워크 설정 > 보안 정책 위배관리 > 보안정책] 룰 아이디 중복 검사
   * @author Song
   * @return {[type]}   [description]
   */
  checkRuleId(param) {
    return axios.post(`${baseUrl}/settings/netdevice-security-policy/check-rule-id.do`, param);
  },
  /**
   * 보안 정책에 적용되어 있는 장비 개수를 조회한다.
   * @param  {Object} params 보안 정책 ID - policyId
   * @return {Number} 관리 대상 개수
   * @author hwang
   */
  getPolicyObjCount(params) {
    return axios.post(`${baseUrl}/settings/netdevice-security-policy/get-policy-obj-count.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/netdevice/netdevice-security-policy-settings.js